module.exports = __webpack_public_path__ + "static/media/anage-select.3fef92eb.svg";